var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 718.5 507.9",
    style: {
      enableBackground: "new 0 0 718.5 507.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;}\n\t.st1{opacity:0.4;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st2{opacity:0.8;fill:url(#SVGID_2_);enable-background:new    ;}\n\t.st3{opacity:0.8;fill:url(#SVGID_3_);enable-background:new    ;}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{opacity:0.3;}\n\t.st8{opacity:0.3;fill:url(#SVGID_7_);enable-background:new    ;}\n\t.st9{opacity:0.3;fill:url(#SVGID_8_);enable-background:new    ;}\n\t.st10{opacity:0.3;fill:url(#SVGID_9_);enable-background:new    ;}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n\t.st14{fill:url(#SVGID_13_);}\n\t.st15{fill:url(#SVGID_14_);}\n\t.st16{fill:url(#SVGID_15_);}\n\t.st17{opacity:0.3;fill:url(#SVGID_16_);enable-background:new    ;}\n\t.st18{opacity:0.3;fill:url(#SVGID_17_);enable-background:new    ;}\n\t.st19{opacity:0.3;fill:url(#SVGID_18_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.2,
    y1: 612.888,
    x2: 267.5,
    y2: 612.888,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6E3C5",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1989,
    style: {
      stopColor: "#E9BB69"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.2,221.4v32.9L267.5,332v-32.9V143.7L151.2,221.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.6,
    y1: 651.738,
    x2: 383.9,
    y2: 651.738,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEDBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2814,
    style: {
      stopColor: "#E3AA3C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M383.9,254.3v-32.9l-116.3,77.7V332L383.9,254.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.2,
    y1: 596.488,
    x2: 383.8,
    y2: 596.488,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124921,
    style: {
      stopColor: "#FFEDBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#E3AA3C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.5,143.7l-116.3,77.8l116.3,77.7l116.3-77.7"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.65,
    y1: 595.738,
    x2: 208.65,
    y2: 407.238,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.5,110v32.9l116.3,77.8v-32.9V32.2L150.5,110z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.9,
    y1: 540.338,
    x2: 383.2,
    y2: 540.338,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M383.2,142.9V110l-116.3,77.7v32.9L383.2,142.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.85,
    y1: 562.738,
    x2: 266.85,
    y2: 407.238,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M266.8,32.2L150.5,110l116.3,77.7L383.2,110"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.35,
    y1: 563.538,
    x2: 209.35,
    y2: 375.038,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.2,77.8v32.9l116.3,77.8v-32.9V0L151.2,77.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.6,
    y1: 508.138,
    x2: 383.9,
    y2: 508.138,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M383.9,110.6V77.8l-116.3,77.7v32.9L383.9,110.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.5,
    y1: 530.538,
    x2: 267.5,
    y2: 375.038,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M267.5,0L151.2,77.8l116.3,77.7l116.3-77.7"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.15,
    y1: 732.838,
    x2: 58.15,
    y2: 544.438,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M0,247.1V280l116.3,77.8v-32.9V169.4L0,247.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.4,
    y1: 677.488,
    x2: 232.7,
    y2: 677.488,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M232.7,280v-32.9l-116.3,77.8v32.9L232.7,280z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.3,
    y1: 699.938,
    x2: 116.3,
    y2: 544.438,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M116.3,169.4L0,247.1l116.3,77.8l116.3-77.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 543.35,
    y1: 882.938,
    x2: 543.35,
    y2: 694.438,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M485.2,397.2v32.9l116.3,77.8V475V319.4L485.2,397.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 601.5,
    y1: 827.588,
    x2: 717.8,
    y2: 827.588,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M717.8,430.1v-32.9L601.5,475v32.9L717.8,430.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 601.5,
    y1: 850.038,
    x2: 601.5,
    y2: 694.438,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M601.5,319.4l-116.3,77.8L601.5,475l116.3-77.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 544.05,
    y1: 850.738,
    x2: 544.05,
    y2: 662.238,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M485.9,365v32.9l116.3,77.8v-32.9V287.2L485.9,365z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.2,
    y1: 795.388,
    x2: 718.5,
    y2: 795.388,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M718.5,397.9V365l-116.3,77.8v32.9L718.5,397.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.2,
    y1: 817.838,
    x2: 602.2,
    y2: 662.238,
    gradientTransform: "matrix(1 0 0 1 0 -375.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98C3A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#2B8341"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M602.2,287.2L485.9,365l116.3,77.8L718.5,365"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash);
export default __webpack_public_path__ + "static/media/splash.c11b6b2b.svg";
export { ForwardRef as ReactComponent };